import { FunctionDocs } from "components/docs";

const SetApiOptions = () => <FunctionDocs entry="setApiOptions" />;

export default SetApiOptions;
